/**
 * @generated SignedSource<<bcd7cc6fe6d611f3cdc787ba5001381d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type GoalScoringMode = "OKR" | "SIMPLE";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
import type { FragmentRefs } from "relay-runtime";
export type storeWorkspace$data = {
  readonly workspace: {
    readonly activationId: string | null;
    readonly cloudId: string;
    readonly cloudName: string | null;
    readonly cloudUrl: string | null;
    readonly goalScoringMode: GoalScoringMode;
    readonly id: string;
    readonly keyPrefix: string;
    readonly name: string;
    readonly organisationId: string;
    readonly timezone: string;
    readonly type: WorkspaceType;
    readonly userHasInvitePermission: boolean | null;
    readonly userIsOrgAdmin: boolean;
    readonly uuid: string;
  } | null;
  readonly workspaceCount: number | null;
  readonly " $fragmentType": "storeWorkspace";
};
export type storeWorkspace$key = {
  readonly " $data"?: storeWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"storeWorkspace">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "storeWorkspace"
};

(node as any).hash = "2974fe6775742fc1c26064f943963db1";

export default node;
